var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.post)?_c('div',{staticClass:"post"},[_c('h1',[_vm._v(" Ich bin in Post.vue")]),_vm._v(" "),_c('h1',{staticClass:"post__title"},[_vm._v(_vm._s(_vm.post.title))]),_vm._v(" "),_c('p',{staticClass:"post__body"},[_vm._v(_vm._s(_vm.post.body))]),_vm._v(" "),_c('p',{staticClass:"post__id"},[_vm._v(_vm._s(_vm.post.id))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }